import React from "react";
import { ErrorMessage } from "formik";
import errorIcon from "assets/Icon_Notification_Warning.png";

const ErrorMessageFormik: React.FC<{ name: string }> = props => (
  <ErrorMessage name={props.name}>
    {msg => (
      <div className="ErrorMessage">
        <div className="Text">{msg}</div>

        <img className="ErrorMessageIcon" src={errorIcon} alt="Error" />
      </div>
    )}
  </ErrorMessage>
);

export default ErrorMessageFormik;
